module.exports = __webpack_public_path__ + "static/media/CanteenTrailBlazer.1e9dfa3e.png";